<template>
   <div class="container-wrapper" v-loading="loading">
      <div class="breadcrumb-wrapper">
         <span>主题跑 / 新增</span>
         <el-button class="back" type="primary" @click="$router.go(-1)">返回</el-button>
      </div>

      <div class="form-wrapper">
         <el-form label-width="145px" label-position="left" :model="formData" :rules="formRules" ref="formRef">
            <el-form-item label="名称" prop="name">
               <el-input placeholder="请输入名称" v-model="formData.name" :disabled="!isOperable">
               </el-input>
            </el-form-item>
            <el-form-item label="排序">
               <el-input-number v-model="formData.orderNum" :min="1" :disabled="!isOperable">
               </el-input-number>
            </el-form-item>
            <el-form-item label="活动H5" prop="jumpUrl">
               <el-input v-model="formData.jumpUrl" :disabled="!isOperable"></el-input>
            </el-form-item>
            <el-form-item label="图片" prop="multipleImage">
               <div class="flex-row-between">
                  <div style="width: 30%;">
                     <div>列表图</div>
                     <UploadImage actionUrl="/adminapi/v1/basicTools/upload/one?uploadImageType=3"
                        tips="（尺寸：，jpg、png、gif）" :urls="formData.listImg" :readonly="!isOperable"
                        @onUrls="listImgUploaded">
                     </UploadImage>
                  </div>
                  <div style="width: 30%;">
                     <div>活动介绍图</div>
                     <UploadImage actionUrl="/adminapi/v1/basicTools/upload/one?uploadImageType=3"
                        tips="（尺寸：，jpg、png、gif）" :urls="formData.url" :readonly="!isOperable"
                        @onUrls="introduceImgUploaded">
                     </UploadImage>
                  </div>
                  <div style="width: 30%;">
                     <div>跑步记录背景图</div>
                     <UploadImage actionUrl="/adminapi/v1/basicTools/upload/one?uploadImageType=3"
                        tips="（尺寸：，jpg、png、gif）" :urls="formData.backgroundImg" :readonly="!isOperable"
                        @onUrls="backgroundImgUploaded">
                     </UploadImage>
                  </div>
               </div>
               <div class="flex-row-between margin-top-20">
                  <div style="width: 30%;">
                     <div>奖牌图（非必填）</div>
                     <UploadImage actionUrl="/adminapi/v1/basicTools/upload/one?uploadImageType=3"
                        :urls="formData.prizeImg" :readonly="!isOperable" @onUrls="prizeImgUploaded">
                     </UploadImage>
                  </div>
                  <div style="width: 30%;">
                     <div>滑动开始图标（非必填）</div>
                     <UploadImage actionUrl="/adminapi/v1/basicTools/upload/one?uploadImageType=3"
                        :urls="formData.slideStartImg" :readonly="!isOperable" @onUrls="slideStartImgUploaded">
                     </UploadImage>
                  </div>
               </div>
            </el-form-item>
            <el-form-item label="奖牌H5" prop="prizeUrl">
               <el-input v-model="formData.prizeUrl" :disabled="!isOperable"></el-input>
            </el-form-item>
            <el-form-item label="活动要求">
               <div class="flex-row">
                  <el-select style="width: 76px;" placeholder="请选择类型" v-model="formData.rewardType"
                     @change="changeRewardType" :disabled="!isOperable">
                     <el-option label="次数" :value="1"></el-option>
                     <el-option label="距离" :value="2"></el-option>
                  </el-select>
                  <div style="width: 36px;">&nbsp;跑步</div>
                  <el-input-number style="width: 86px;" :controls="false" :min="0"
                     v-model="formData.rewardValue.threshold" :disabled="!isOperable">
                  </el-input-number>
                  <div v-if="formData.rewardType == 1">次，获得奖励，每日计入一次</div>
                  <div v-if="formData.rewardType == 2">米，获得奖励，每日最高计入</div>
                  <el-input-number v-if="formData.rewardType == 2" style="width: 86px;" :controls="false" :min="0"
                     v-model="formData.rewardValue.oneDay" :disabled="!isOperable"></el-input-number>
                  <div v-if="formData.rewardType == 2">米</div>
               </div>
            </el-form-item>
            <el-form-item label="默认展示奖牌图/徽章">
               <el-switch v-model="formData.showBadge" :disabled="!isOperable" on-text="" off-text="" active-text="">
               </el-switch>
            </el-form-item>
            <el-form-item label="平台">
               <el-radio-group style="display: flex; line-height: 36px" v-model="formData.osType">
                  <el-radio :label="-1" :disabled="!isOperable">全部</el-radio>
                  <el-radio :label="0" :disabled="!isOperable">安卓</el-radio>
                  <el-radio :label="1" :disabled="!isOperable">iOS</el-radio>
                  <el-radio :label="2" :disabled="!isOperable">鸿蒙</el-radio>
               </el-radio-group>
            </el-form-item>
            <el-form-item label="适用学校">
               <el-radio-group style="display: flex; line-height: 36px" v-model="formData.type" @change="changeCampus">
                  <el-radio :label="0" :disabled="!isOperable">全部</el-radio>
                  <el-radio :label="1" :disabled="!isOperable">部分</el-radio>
               </el-radio-group>
            </el-form-item>
            <el-form-item :label="formData.type ? '应用学校' : '屏蔽学校'" :required="formData.type ? true : false"
               prop="rootUnids">
               <div style="display: flex; align-items: center">
                  <el-select style="flex: 1; margin-right: 8px" placeholder="请选择学校" v-model="schoolData" filterable
                     :disabled="!isOperable">
                     <el-option v-for="(item, index) in schoolDataSource" :key="index" :label="item.label"
                        :value="item.value">
                     </el-option>
                  </el-select>
                  <el-button @click="clickAddSchools" :disabled="!isOperable">添加</el-button>
               </div>
               <div class="card-wrap">
                  <div v-for="item in formData.rootUnids" :key="item.value" class="card-item">
                     <span>{{ item.label }}</span>
                     <el-button type="text" icon="circle-close" :disabled="!isOperable"
                        @click="clickDeleteSchools(item.value)">
                     </el-button>
                  </div>
               </div>
               <div class="card-footer">共计{{ formData.rootUnids.length }}所学校</div>
            </el-form-item>
            <el-form-item label="有效时间" prop="dateRange">
               <div class="flex-row-between">
                  <el-date-picker class="date-picker" type="datetime" placeholder="起始日期" v-model="formData.beginTime"
                     :disabled="!isOperable">
                  </el-date-picker>
                  <div>&nbsp;至&nbsp;</div>
                  <el-date-picker class="date-picker" type="datetime" placeholder="截止日期" v-model="formData.endTime"
                     :disabled="!isOperable">
                  </el-date-picker>
               </div>
            </el-form-item>
            <el-form-item label="选配">
               <div>可部分上传，未上传的位置取默认配置</div>
               <div>
                  <div style="font-weight: bold;">图片包</div>
                  <UploadFile actionUrl="/adminapi/v1/basicTools/v650/file/upload?uploadImageType=3&fileType=2"
                     accept=".zip" tips="按照对应位置状态命名，并打包成压缩包，仅支持.ZIP文件上传。 (ZIP包大小不超过600M)" :urls="formData.optionalImg"
                     :readonly="!isOperable" @onUrls="optionalImgUploaded">
                  </UploadFile>
                  <div class="margin-top-10">命名规则：点位+@2X；点位+@3X。一个点位需配置两套</div>
                  <div>起点（img_point_start）终点（img_point_end）</div>
                  <div>正常点置灰（img_point_normal）正常点亮（img_point_normal_pass）</div>
                  <div>必经点置灰（img_point_must_normal）、必经点点亮（img_point_must_pass）</div>
                  <div>点位1置灰（run_point_first_lock）、点位1准备中（run_point_first）</div>
                  <div>点位2置灰（run_point_second_lock）、 点位2准备中（run_point_second）</div>
                  <div>点位3置灰（run_point_third_lock）、点位3准备中（run_point_third）</div>
                  <div>点位4置灰（run_point_fourth_lock）、点位4准备中（run_point_fourth）</div>
                  <div>点位5置灰（run_point_fifth_lock）、点位5准备中（run_point_fifth）</div>
                  <div>分配终点（img_point_assign_end_normal）</div>
                  <div>分配终点经过（img_point_assign_end_pass）</div>
               </div>
               <div>
                  <div style="font-weight: bold;">音频</div>
                  <UploadFile actionUrl="/adminapi/v1/basicTools/v650/file/upload?uploadImageType=3&fileType=2"
                     accept=".zip" tips="按照位置命名，并打包成压缩包，仅支持.ZIP文件上传。 (ZIP包大小不超过600M)" :urls="formData.optionalVideo"
                     :readonly="!isOperable" @onUrls="optionalVideoUploaded">
                  </UploadFile>
                  <div>命名规则：将图片按位置命名（位置）</div>
                  <div>位置：</div>
                  <div>跑步开始（run_start）、必经点（run_fixed）、终点（run_destination）、</div>
                  <div>暂停（run_pause）、重新开始（run_resume）、完成跑步（run_finish）、</div>
                  <div>点位1（run_ordinary1）、点位2（run _ordinary2）、</div>
                  <div>点位3（run_ordinary3）、点位4（run_ordinary4）</div>
               </div>
            </el-form-item>
         </el-form>
      </div>

      <div class="margin-20" v-if="isOperable">
         <el-button type="primary" @click="clickSave()">保存</el-button>
      </div>
   </div>
</template>

<script>
import UploadImage from "../../../../components/UploadItems/UploadImage.vue";
import UploadFile from "../../../../components/UploadItems/UploadFile.vue";

export default {
   components: {
      UploadImage,
      UploadFile
   },

   data() {
      const validMultipleImage = (rule, value, callback) => {
         if (!this.formData.listImg) {
            return callback(new Error("请上传列表图"));
         }
         if (!this.formData.backgroundImg) {
            return callback(new Error("请上传跑步记录背景图"));
         }
         callback();
      };

      const validRequirement = (rule, value, callback) => {
         if (this.formData.rewardType == 1 && this.formData.rewardValue.threshold == 0) {
            return callback(new Error("请输入跑步次数"));
         }
         if (this.formData.rewardType == 2 && this.formData.rewardValue.threshold == 0) {
            return callback(new Error("请输入跑步米数"));
         }
         if (this.formData.rewardType == 2 && this.formData.rewardValue.oneDay == 0) {
            return callback(new Error("请输入每日最高计入米数"));
         }
         callback();
      };

      const validateSchool = (rule, value, callback) => {
         if (this.formData.type && (!value || !value.length)) {
            return callback(new Error("学校不能为空"));
         }
         callback();
      };

      const validDate = (rule, value, callback) => {
         if (!this.formData.beginTime || !this.formData.endTime) {
            return callback(new Error("请选择有效时间"));
         }
         if (this.formData.beginTime > this.formData.endTime) {
            return callback(new Error("起始时间不能晚于截止时间"));
         }
         callback();
      };

      return {
         loading: false,
         isOperable: true, // 是否可操作
         id: "",
         originInfo: {}, // 原详情信息
         hasQuery: false, // 是否有网络请求
         formData: {
            name: "",
            orderNum: 1,
            jumpUrl: "",
            listImg: "",
            url: "",
            backgroundImg: "",
            prizeImg: "",
            slideStartImg: "",
            prizeUrl: "",
            rewardType: 1,
            rewardValue: {
               oneDay: 1,
               threshold: 0,
            },
            type: 0,
            rootUnids: [],
            beginTime: "",
            endTime: "",
            optionalImg: "",
            optionalVideo: "",
            showBadge: false,
            osType: -1,
         },
         formRules: {
            name: { required: true, message: "请输入名称", trigger: "blur" },
            // jumpUrl: { required: true, message: "请输入", trigger: "blur" },
            multipleImage: { required: true, validator: validMultipleImage, trigger: "blur" },
            rootUnids: { validator: validateSchool, trigger: "change", },
            dateRange: { required: true, validator: validDate, trigger: "change", },
         },
         schoolDataSource: [],
         schoolData: "",
      }
   },

   mounted() {
      const queryInfo = this.$route.query;
      if (queryInfo.actionType === 'detail') {
         this.isOperable = false;
      }
      if (queryInfo.id) {
         this.id = this.$route.query.id;
         this.queryDetailInfo();
      }
      this.queryALLSchool();
   },

   methods: {
      // 查询详情信息
      queryDetailInfo() {
         this.loading = true;
         this.$http({
            url: this.$util.domain + "/adminapi/v1/operate/activity/run/theme/queryById",
            method: "GET",
            params: { id: this.id }
         }).then((res) => {
            if (res.body.data && JSON.stringify(res.body.data) !== "{}") {
               const data = res.body.data;
               this.id = data.id;
               this.formData.name = data.name;
               this.formData.orderNum = data.orderNum || 1;
               this.formData.jumpUrl = data.jumpUrl;
               this.formData.listImg = data.listImg;
               this.formData.url = data.url;
               this.formData.backgroundImg = data.backgroundImg;
               this.formData.prizeImg = data.prizeImg;
               this.formData.slideStartImg = data.slideStartImg;
               this.formData.prizeUrl = data.prizeUrl;
               this.formData.rewardType = data.rewardType || 1;
               const rewardValue = data.rewardValue ? JSON.parse(data.rewardValue) : {};
               this.formData.rewardValue = {
                  oneDay: rewardValue.oneDay,
                  threshold: rewardValue.threshold
               };
               this.formData.type = data.type;
               this.formData.rootUnids = data.activityRunThemeSchoolList ? data.activityRunThemeSchoolList.map((item) => ({
                  label: item.name,
                  value: item.rootUnid,
               })) : [];
               this.formData.beginTime = new Date(data.beginTime);
               this.formData.endTime = new Date(data.endTime);
               this.formData.optionalImg = data.optionalImg;
               this.formData.optionalVideo = data.optionalVideo;
               this.formData.showBadge = data.showBadge == 1 || false;
               this.formData.osType = data.osType;
               this.originInfo = data;
               this.hasQuery = true;
            }
         }).catch((error) => {
            this.$util.errorMsg('获取详情信息失败');
         }).finally(() => {
            this.loading = false;
         });
      },

      // 查询全部学校
      queryALLSchool() {
         this.$http({
            url: this.$util.domain + "/adminapi/v1/basicTools/allSchools",
            method: "GET",
         }).then((res) => {
            if (res.body.data && res.body.data.length) {
               this.schoolDataSource = res.body.data.map((item) => ({
                  label: item.name,
                  value: item.rootUnid,
               }));
            } else {
               this.schoolDataSource = [];
            }
         }).catch((error) => {
            this.schoolDataSource = [];
         });
      },

      // 发送信息
      sendInfo() {
         let rootUnids = [];
         if (this.formData.rootUnids && this.formData.rootUnids.length) {
            rootUnids = this.formData.rootUnids.map((item) => item.value);
         }
         let params = {
            ...this.formData,
            rootUnids,
            rewardValue: JSON.stringify(this.formData.rewardValue),
            beginTime: new Date(this.formData.beginTime).getTime(),
            endTime: new Date(this.formData.endTime).getTime(),
            showBadge: this.formData.showBadge == 1 ? 1 : 0,
         };
         if (this.id) {
            params['id'] = this.id;
            const rootUnidStr = JSON.stringify(params.rootUnids);
            let originRootUnids = [];
            if (this.originInfo.activityRunThemeSchoolList) {
               originRootUnids = this.originInfo.activityRunThemeSchoolList.map((item) => item.rootUnid) || [];
            }
            const originStr = JSON.stringify(originRootUnids || []);
            if (params.type == this.originInfo.type && rootUnidStr === originStr) {
               params['rootUnidsChanged'] = 0; // 0：校区未变动，1校区有变动   
            } else {
               params['rootUnidsChanged'] = 1; // 0：校区未变动，1校区有变动
            }
         }
         this.loading = true;
         this.$http({
            url: this.$util.domain + "/adminapi/v1/operate/activity/run/theme/addOrUpdate",
            method: "POST",
            dataType: "json",
            body: JSON.stringify({ ...params })
         }).then((res) => {
            if (res.body.error === 10000) {
               this.$router.go(-1);
            } else {
               this.$util.errorMsg(res.body.message);
            }
         }).catch((err) => {
            this.$util.errorMsg(err.message);
         }).finally(() => {
            this.loading = false;
         });
      },

      // 列表图上传成功
      listImgUploaded(img) {
         this.formData.listImg = img;
      },

      // 活动介绍图上传成功
      introduceImgUploaded(img) {
         this.formData.url = img;
      },

      // 跑步记录背景图上传成功
      backgroundImgUploaded(img) {
         this.formData.backgroundImg = img;
      },

      // 奖品图上传成功
      prizeImgUploaded(img) {
         this.formData.prizeImg = img;
      },

      // 滑动开始图标上传成功
      slideStartImgUploaded(img) {
         this.formData.slideStartImg = img;
      },

      // 切换要求类型
      changeRewardType() {
         if (this.formData.rewardType == 1) {
            this.formData.rewardValue.oneDay = 1;
         }
      },

      // 切换学校
      changeCampus() {
         if (this.hasQuery) { // 为了规避网络请求之后赋值type时导致这个方法的调用
            this.hasQuery = false;
            return;
         }
         this.schoolData = null;
         this.formData.rootUnids = [];
      },

      // 点击添加学校
      clickAddSchools() {
         const datad = this.formData.rootUnids.find((item) => {
            return item.value === this.schoolData;
         });
         if (datad && JSON.stringify(datad) !== "{}") {
            this.schoolData = null;
            return;
         }
         const data = this.schoolDataSource.find((item) => {
            return item.value === this.schoolData;
         });
         if (data && JSON.stringify(data) !== "{}") {
            this.formData.rootUnids = [...this.formData.rootUnids, data];
            this.schoolData = "";
         }
      },

      // 点击删除学校
      clickDeleteSchools(unid) {
         const index = this.formData.rootUnids
            .map((item) => item.value)
            .indexOf(unid);
         this.formData.rootUnids.splice(index, 1);
      },

      // 图片包上传成功
      optionalImgUploaded(url) {
         this.formData.optionalImg = url;
      },

      // 音频上传成功
      optionalVideoUploaded(url) {
         this.formData.optionalVideo = url;
      },

      // 点击保存
      clickSave() {
         this.$refs.formRef.validate((valid) => {
            if (valid) {
               this.sendInfo();
            }
         });
      },
   }
}
</script>

<style scoped>
.card-wrap {
   width: 100%;
   height: 200px;
   margin: 8px 0 4px;
   padding: 10px;
   box-sizing: border-box;
   border: 1px solid #c0ccda;
   border-radius: 4px;
   overflow: auto;
   gap: 10px;
}

.card-footer {
   text-align: right;
   font-size: 14px;
   line-height: 1.5;
}

.card-item {
   display: inline-block;
   margin: 4px 4px;
   padding: 0px 4px;
   border: 1px solid #c0ccda;
   border-radius: 4px;
   font-size: 14px;
   line-height: 1.5;
}

.date-picker {
   width: 48%;
}
</style>


// WEBPACK FOOTER //
// ThemeDetail.vue?1f6b0874